import {
    boxesENG,
    situationsENG,
    slidesENG,
    buyHeadersENG,
    authorsENG,
} from "../../eng_resources";

const translationEnglish = {
    en: {
        translation: {
            siteIsNotBeingUsedInfo:
                "This site is no longer available or active. It serves only for presentation purposes!",
            navigation: {
                examples: {
                    name: "Examples of use",
                    link: "examples",
                },
                about: {
                    name: "About planner",
                    link: "about",
                },
                contact: {
                    name: "Contact",
                    link: "contact",
                },
                newsletter: {
                    name: "Newsletter",
                    link: "newsletter",
                },
                changeLanguage: {
                    name: "Change Language",
                },
            },

            externalLinks: {
                shop: "https://get-creative-everyday-demo.netlify.app/",
            },

            boxes: boxesENG,

            quotes: {
                possible: "Is it really possible?",
                organiser:
                    "An organiser, your lesson wizard and time-saver all in one?",
                teachers:
                    "Dedicated to the teachers of English (English taught as a foreign language)?",
                tool: "More of a tool than just a planner?",
            },

            situations: situationsENG,

            slides: slidesENG,

            buyHeaders: buyHeadersENG,

            authorsDescriptions: authorsENG,

            atoms: {
                header: `<b>Both a calendar and planner</b> including
                ready-to-use ideas for English lessons with
                <br />
                <b>young learners</b>`,

                buyNow: "Buy now",

                signUp: "Sign Up",

                hereYouAre: "Here you are",

                creativityBoost:
                    "Your everyday boost of creativity in teaching!",

                isPlannerGoodForYou:
                    "Is the planner Get Creative Every Day suitable for you?",

                checkItOut: "Check it out!",

                meetExpectations:
                    "Are you still looking for an ideal planner that will meet all your expectations?",

                youFoundIt: "You've just found it!",

                fromTeachersToTeachers: "From teachers to teachers",

                authorsCircle: {
                    content:
                        "All content pages have been created by teachers of English. They are based on ideas tested in their daily practice. Part of the materials used in GC planner derive <b>from</b>",
                    span: "Get Creative magazine resources",
                },

                authorsContribution: "Some of the authors who contributed are:",

                notEnoughInfo: "Still not enough information?",
                signUpForNewsletter:
                    "Sign up for our newsletter to get some details!",

                yourEmail: "Your email adress",

                messages: {
                    emailSaved: "Email has been saved!",
                    emailNotSaved:
                        "Email has not beed saved. Please try again later.",
                    emailExist: "Email has already been registered!",
                },

                from: "from",

                polish: "polski",
                english: "english",
                spanish: "española",
            },
        },
    },
};

export default translationEnglish;
